import { rootURL } from '../constants';

function request({method,url,data}){
    return new Promise( (resolve,reject) => {
        var xhr = new XMLHttpRequest();
        xhr.onload = function(){
            if (xhr.status >= 200 && xhr.status < 300) {
                const data = response();
                resolve(response());
            } else {
                error();
            }            
        }
        xhr.onerror = xhr.onabort = error;
        function error(){
            reject(response() || {ExceptionMessage:'Cannot connect to server, please try again in a few minutes.'});
        }
        function response(){
            return typeof xhr.response === 'string' ? JSON.parse(xhr.response) : xhr.response;
        }
        xhr.open(method,
            (url.indexOf('.json') === -1 && url.indexOf('https://') === -1 && url.indexOf('http://') === -1 ? rootURL : '') + 
            url + 
            (method === 'GET' && !!data ? '?' + Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&') : '')
        );
        xhr.setRequestHeader('Accept','application/json, text/plain, */*');
        if(method === 'POST'){
            xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded; charset=UTF-8');
        }
        
        xhr.responseType = 'json';
        xhr.send(data ? method === 'POST' ? data : JSON.stringify(data) : undefined);    
    });
}

function http(url){
    return {
        get(data){
            return request({method:'GET',url,data});
        },
        create(data){
            if(typeof data === 'object'){
                data = (new URLSearchParams(data)).toString()
            }
            return request({method:'POST',url,data});
        }
    };
}

export default http;